import React from "react";
import "./StepTwo.css";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  Typography,
  styled,
} from "@mui/material";
import { stepTwoData } from "../stepsData";

import Calculator from "./Calculator/Calculator.jsx";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import tongueOut from "../../../../Assets/Images/tongue-out.png";

const StepTwo = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  // Styling Table Cell
  const tableHeadingsStyle = {
    xs: "14px",
    lg: "16px",
  };
  const tableContentStyle = {
    md: "14px",
    lg: "16px",
  };

  return (
    <>
      <div className="step-two mt-2 ">
        <Typography
          sx={{
            fontSize: "23.8532px",
            color: "#1F1F1F",
            fontFamily: "'Archivo', sans-serif",
          }}
          className="archivo fw-bold"
        >
          {stepTwoData[0].stepTwoHeading}
        </Typography>
        <div>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              color: "#1F1F1F",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo mt-2"
          >
            {stepTwoData[0].decideBeforeTakeLoan}
          </Typography>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              color: "#1F1F1F",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo mt-2"
          >
            {" "}
            {stepTwoData[0].thenEstimate}{" "}
          </Typography>
        </div>
        <div className="mt-3">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#e7e4f9",
                  }}
                >
                  {stepTwoData[0].loanPaymentsTable &&
                    stepTwoData[0].loanPaymentsTable.heading.map(
                      (item, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            fontSize: tableHeadingsStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #c7c7c7",
                          }}
                          className="archivo"
                        >
                          {item.head}
                        </TableCell>
                      )
                    )}
                </TableRow>
              </TableHead>
              <TableBody>
                {stepTwoData[0].loanPaymentsTable.rows &&
                  stepTwoData[0].loanPaymentsTable.rows.map((item, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                        }}
                      >
                        {item.creditRating}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                        }}
                      >
                        {item.score}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                        }}
                      >
                        {item.estimated}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className="mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              color: "#1F1F1F",
              fontStyle: "italic",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo"
          >
            Disclaimer: {stepTwoData[0].disclaimer}
          </Typography>
        </div>
        <section className="loan_calculator d-flex gap-4 rounded mt-4 ">
          <Calculator />
        </section>

        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Loan Tenure Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Consider how long you’ll need to pay off the loan. Longer loan
                  tenures mean smaller monthly payments, but you’ll pay more in
                  interest over time. Choosing a shorter tenure can save you
                  interest if it comfortably fits within your budget.
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button
        sx={{
          textTransform: "none",
          margin: "0px",
          fontSize: 16,
          fontFamily: "'Archivo', sans-serif",
        }}
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="d-flex algin-items-center archivo mt-2"
      >
        <FontAwesomeIcon icon={faArrowUp} /> &nbsp; Back To Top
      </Button>
    </>
  );
};

export default StepTwo;
